import { FC, useEffect, useState } from 'react'

import ByFashionTechNews from '../ByFashionTechNews'
import Link from '@atoms/Link'
import ArtisanLogo from '@atoms/ArtisanLogo'
import LanguageSwitch from '@molecules/LanguageSwitch'
import Instagram from '@icons/Instagram'
import { ArtisanPageHeading } from '@src/pages/artisan'
import { useTranslation } from '@models/Translation'
import { mailToArtisan } from '@models/Util'

import * as style from './style.module.sass'

export type ArtisanHeaderProps = {
  handleClickHeading?: (heading: ArtisanPageHeading) => void
}

const ArtisanHeader: FC<ArtisanHeaderProps> = ({ handleClickHeading }) => {
  const [showHeader, setShowHeader] = useState(true)
  const [showMenu, setShowMenu] = useState(false)
  const { locale } = useTranslation()

  useEffect(() => {
    let lastScrollTop = 0

    const onScroll = () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      const scrollDiff = scrollTop - lastScrollTop

      // 一番上に行くと若干戻るので20以下だったら表示するようにする
      setShowHeader(scrollTop < 20 || scrollDiff < 0)

      lastScrollTop = scrollTop
    }

    // イベントが残っているかもしれないので削除
    document.removeEventListener('scroll', onScroll)
    document.addEventListener('scroll', onScroll)

    return () => {
      document.removeEventListener('scroll', onScroll)
    }
  }, [])

  return (
    <>
      <header
        className={style.header}
        data-show-header={showMenu || showHeader}
      >
        <Link to="/artisan">
          <div className={style.headerLogo} data-show={!showMenu}>
            <ArtisanLogo />
          </div>
        </Link>
        <div className={style.contents}>
          {handleClickHeading && (
            <div className={style.headings} data-show={!showMenu}>
              <button
                onClick={() => {
                  handleClickHeading('video')
                }}
              >
                VIDEOS
              </button>
              <button
                onClick={() => {
                  handleClickHeading('location')
                }}
              >
                LOCATION
              </button>
              <button
                onClick={() => {
                  handleClickHeading('articles')
                }}
              >
                ARTICLES
              </button>
              <button
                onClick={() => {
                  handleClickHeading('column')
                }}
              >
                SPECIAL COLUMN
              </button>
              <button
                onClick={() => {
                  handleClickHeading('instagram')
                }}
              >
                INSTAGRAM
              </button>
            </div>
          )}
          <button
            className={style.menuSwitch}
            data-show-menu={showMenu}
            onClick={() => {
              setShowMenu(!showMenu)
            }}
          >
            <div className={style.borderA} />
            <div className={style.borderB} />
          </button>
        </div>
      </header>

      <menu className={style.menuModal} data-show-menu={showMenu}>
        <div className={style.menu}>
          <Link to="/artisan" className={style.menuLogo}>
            <ArtisanLogo />
          </Link>
          <Link
            to="https://www.instagram.com/ftn_artisan/"
            className={style.instagram}
          >
            <Instagram />
          </Link>
          <Link to="/artisan/about" className={style.link}>
            <h3>ABOUT</h3>
          </Link>
          <Link
            to={
              locale === 'en'
                ? 'https://zozonext.com/en/privacy'
                : 'https://zozonext.com/privacy'
            }
            className={style.link}
          >
            <h3>PRIVACY POLICY</h3>
          </Link>
          <a href={mailToArtisan(locale)} className={style.link}>
            <h3>CONTACT</h3>
          </a>
          <div className={style.language}>
            <LanguageSwitch />
          </div>
          <div className={style.footer}>
            <ByFashionTechNews />
          </div>
        </div>
      </menu>
    </>
  )
}

export default ArtisanHeader
